<template>
  <div class="spend-item">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-subtitle style="text-transform: capitalize">{{ formatDate(item.date) }}</v-list-item-subtitle>
        <v-list-item-title>
          <strong>{{ item.store }}:</strong>
          {{ formatAmount(item.amount) }} DKK
        </v-list-item-title>
        <v-list-item-subtitle>
          <strong>Kategori:</strong>
          {{ item.category }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "spend-item",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatAmount(amount) {
      let number = parseFloat(amount);
      return number.toFixed(2);
    },
    formatDate(date) {
      return moment(date)
        .locale("da-DK")
        .format("ddd D. MMMM");
    }
  }
};
</script>
